import Vue from 'vue'

const CardInstance = Vue.extend(require('./card.vue').default);
let instance = null

let getInstance = () => {
  return new CardInstance({
    el: document.createElement('div')
  })
}

let close = () => {
  instance.close()
  if(instance && instance.$el && instance.$el.parentNode){
    instance.$el.parentNode.removeChild(instance.$el);
  }
  instance = null
}

let Card = (id, el, type) => {
  if (instance) {
    close()
  }
  instance = getInstance()

  el.appendChild(instance.$el);
  instance.open(id, type)
}


export default Card
